export default {
  apiGateway: {
    REGION: 'us-west-2',
    URL: process.env.REACT_APP_GATEWAY_URL,
  },
};
